import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CatalogLoadingComponent } from './catalog-loading.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { FlexLayoutModule } from '@angular/flex-layout';

@NgModule({
  imports: [
    CommonModule,
    NgxSkeletonLoaderModule,
    FlexLayoutModule
  ],
  declarations: [
    CatalogLoadingComponent
  ],
  exports: [
    CatalogLoadingComponent
  ],
})
export class CatalogLoadingModule {}
